import React, { FormEvent } from 'react'
import { Modal } from '@entur/modal'
import { SecondaryButton, NegativeButton } from '@entur/button'
import { useToast } from '@entur/alert'
import { Paragraph } from '@entur/typography'
import { FetchState, FamilyMember } from '../../api-clients/api-types'
import { useApi } from '../../api-clients/client-hooks'
import { patchFamilyMember } from '../../api-clients/eba-clients'
import { trackEvent } from '../../utils/tracking-utils'
import { ModalErrorAlert } from '../modal/modal-error-alert'

type FamilyMemberModalProps = {
  open?: boolean
  familyMember: FamilyMember
  close: (shouldUpdate: boolean) => void
}
const DeleteFamilyMemberModal: React.FC<FamilyMemberModalProps> = (props) => {
  const { addToast } = useToast()
  const [patchResponse, doPatch] = useApi(patchFamilyMember, {
    successCallback: (_data) => {
      addToast({
        title: 'Familiemedlem er slettet!',
        content: 'De er ikke lenger tilgjengelig under fanen "Familiemedlemmer".',
      })
      props.close(true)
    },
  })

  const patch = (e: FormEvent) => {
    e.preventDefault()
    trackEvent('Delete-Family-Member', { category: 'Family-Member', relation: props.familyMember?.relation.code })
    doPatch({
      id: props.familyMember?.id,
      body: { isDeleted: true },
    })
  }

  return (
    <Modal
      className="delete-family-member-modal"
      data-cy="delete-family-member-modal"
      open={props.open}
      title="Slette familiemedlem"
      size="medium"
      onDismiss={() => props.close(false)}
    >
      <Paragraph className="spacing-medium">
        Er du sikker på at du vil slette "{props.familyMember.surname}, {props.familyMember.firstName}”?
      </Paragraph>
      <div className="spacing-top-extra-large5">
        {patchResponse.status === FetchState.ERROR && <ModalErrorAlert title="Sletting feilet" />}

        <NegativeButton
          loading={patchResponse.status === FetchState.LOADING}
          onClick={patch}
          className="spacing-right-medium"
        >
          Slett familiemedlem
        </NegativeButton>
        <SecondaryButton onClick={() => props.close(false)}>Avbryt sletting</SecondaryButton>
      </div>
    </Modal>
  )
}

export default DeleteFamilyMemberModal
